namespace $.$$ {

	const Resizer_size = 'var(--shm_hitalama_map_widget_float_resizer_size)' as any
	const Resizer_shift = 'calc(var(--shm_hitalama_map_widget_float_resizer_size) * -0.5)' as any

	$mol_style_define( $shm_hitalama_map_float, {

		contain: 'none',
		userSelect: 'none',

		Outline_top: {
			position: 'absolute',
			top: 0,
			left: 0,
			width: '100%',
			height: '1px',
			pointerEvents: 'none',
			transformOrigin: '0 0',
			zIndex: $mol_layer.float,
		},

		Outline_left: {
			position: 'absolute',
			top: 0,
			left: 0,
			width: '1px',
			height: '100%',
			pointerEvents: 'none',
			transformOrigin: '0 0',
			zIndex: $mol_layer.float,
		},

		Outline_bottom: {
			position: 'absolute',
			bottom: 0,
			left: 0,
			width: '100%',
			height: '1px',
			pointerEvents: 'none',
			transformOrigin: '0 100%',
			zIndex: $mol_layer.float,
		},

		Outline_right: {
			position: 'absolute',
			top: 0,
			right: 0,
			width: '1px',
			height: '100%',
			pointerEvents: 'none',
			transformOrigin: '100% 0',
			zIndex: $mol_layer.float,
		},

		Top_left_edge: {
			opacity: 1,
			outline: '1px solid var(--mol_theme_current)',
			transition: 'none',
			top: Resizer_shift,
			left: Resizer_shift,
			width: Resizer_size,
			height: Resizer_size,
		},

		Top_right_edge: {
			opacity: 1,
			outline: '1px solid var(--mol_theme_current)',
			transition: 'none',
			top: Resizer_shift,
			right: Resizer_shift,
			width: Resizer_size,
			height: Resizer_size,
		},

		Bottom_left_edge: {
			opacity: 1,
			outline: '1px solid var(--mol_theme_current)',
			transition: 'none',
			bottom: Resizer_shift,
			left: Resizer_shift,
			width: Resizer_size,
			height: Resizer_size,
		},

		Bottom_right_edge: {
			opacity: 1,
			outline: '1px solid var(--mol_theme_current)',
			transition: 'none',
			right: Resizer_shift,
			bottom: Resizer_shift,
			width: Resizer_size,
			height: Resizer_size,
		},

		Top_edge: {
			top: Resizer_shift,
			height: Resizer_size,
			transition: 'none',
		},

		Left_edge: {
			left: Resizer_shift,
			width: Resizer_size,
			transition: 'none',
		},

		Bottom_edge: {
			bottom: Resizer_shift,
			height: Resizer_size,
			transition: 'none',
		},

		Right_edge: {
			right: Resizer_shift,
			width: Resizer_size,
			transition: 'none',
		},

		Left_top_edge_ratio: {
			left: Resizer_shift,
			width: Resizer_size,
			transition: 'none',
		},

		Left_bottom_edge_ratio: {
			left: Resizer_shift,
			width: Resizer_size,
			transition: 'none',
		},

		Right_top_edge_ratio: {
			right: Resizer_shift,
			width: Resizer_size,
			transition: 'none',
		},

		Right_bottom_edge_ratio: {
			right: Resizer_shift,
			width: Resizer_size,
			transition: 'none',
		},

		Top_left_edge_ratio: {
			top: Resizer_shift,
			height: Resizer_size,
			transition: 'none',
		},

		Top_right_edge_ratio: {
			top: Resizer_shift,
			height: Resizer_size,
			transition: 'none',
		},

		Bottom_left_edge_ratio: {
			bottom: Resizer_shift,
			height: Resizer_size,
			transition: 'none',
		},

		Bottom_right_edge_ratio: {
			bottom: Resizer_shift,
			height: Resizer_size,
			transition: 'none',
		},

		Toolbar: {
			position: 'absolute',
			top: 0,
			width: '100%',
			transition: 'none',
			overflow: 'visible',
			transformOrigin: '0 100%',
			zIndex: $mol_layer.popup,
			padding: {
				bottom: $mol_gap.space,
			},
			pointerEvents: 'none',
			['$mol_view']: {
				pointerEvents: 'auto',
			},
		},

		Sidebar: {
			position: 'absolute',
			top: 0,
			right: '-5px',
			transform: 'translateX(100%)',
			overflow: 'visible',
			flex: {
				direction: 'column',
			},
			background: {
				color: $mol_theme.card,
			},
		},

		Drag_overlap: {
			zIndex: 10,
			position: 'absolute',
			width: '100%',
			height: '100%',
		},

	} )

}
